import { fetchData } from '@/utilities/API/apiUtility';

// GET UIM GUID
export async function getGUID(email) {
  try {
    const getUserInfoByEmail = process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_GET_USER_INFO_BY_EMAIL;
    const response = await fetchData(getUserInfoByEmail + "Email=" + email);
    if (response) {
      if (response.status == 200) {
        if (response.data) {
          return response.data.guID;
        } else {
          return null;
        }
      }
    }
  } catch (error) {
    return null;
  }
}

export async function getUserDetailsFromStripe(product, userID) {
  var searchCustomerApiUrl =
    process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_SearchCustomer;

  searchCustomerApiUrl = searchCustomerApiUrl
    .replace("{product}", product)
    .replace("{uimId}", userID);

  try {
    const response = await fetchData(searchCustomerApiUrl);

    if (response && response.status === 200 && response.data.length > 0) {
      return response.data[0];
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
}

export async function getCustomerFromStripe(userID) {
  var getStripeCustomer  =
    process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_GetCustomer;

    getStripeCustomer = getStripeCustomer
    .replace("{userId}", userID);

  try {
    const response = await fetchData(getStripeCustomer);
    
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("An error occurred while fetching the customer details", error);
  }
}

export async function getCreditCardInfo(customerID) {
  let getCreditCardInfoURL =
    process.env.VUE_APP_BackEndAPI +
    process.env.VUE_APP_GET_CREDIT_CARD_DETAILS;
  getCreditCardInfoURL = getCreditCardInfoURL.replace(
    "{customerId}",
    customerID
  );
  try {
    const response = await fetchData(getCreditCardInfoURL);

    if (response && response.status === 200 && response.data.length > 0) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
}

export async function getDefaultCreditCard(customerID){
  var data = await getCreditCardInfo(customerID);
  for (let i = 0; i < data.length; i++) {
    if (data[i].isPrimary) {
        data = data[i];
        break;
    }
  }
  return data;
}
  